import * as T from '@/types'
import router from '@/router'
import { Route, RouteConfig } from 'vue-router'

import _merge from 'lodash/merge'
import _cloneDeep from 'lodash/cloneDeep'
import _set from 'lodash/set'
import _get from 'lodash/get'

export function routeIsWithin (routeName: T.CrmRoute, currentRoute?: Route) {
    const routeToUse = currentRoute || router.currentRoute
    return !!routeToUse.matched.find((route) => route.name === routeName)
}

export function routeIs (routeName: T.CrmRoute) {
    return router.currentRoute.name === routeName
}

export function routeIsOneOf (routeNames: T.CrmRoute[]) {
    return routeNames.includes(router.currentRoute.name as T.CrmRoute)
}

export function routeHasSelection () {
    return router.currentRoute.query['selected'] == 'all' ||
        (router.currentRoute.query['selected[]'] && router.currentRoute.query['selected[]'].length > 0)
}

export function layoutGroup (routes: RouteConfig[], defaultConfig: Partial<RouteConfig>) {
    return routes.map((route) => {
        const result = _merge(_cloneDeep(defaultConfig), {
            ...route,
        })

        return result
    })   
}

////////////////////////////////////////////////////////////////
// query
////////////////////////////////////////////////////////////////

export function isQueryValueEqualTo (key: string, value: any, route?: Route) {
    const routeToUse = route || router.currentRoute
    const actualValue = routeToUse.query[key]

    return actualValue === value || actualValue === `${value}`
}

export function mergeIntoQuery (changes: T.Dictionary<any>, route?: Route) {
    const existingRoute = route || router.currentRoute

    return {
        ...existingRoute,
        query: {
            ...existingRoute.query,
            ...changes,
        },
    }
}

export function replaceQuery (query: T.Dictionary<any>) {
    router.replace({
        ...router.currentRoute,
        query,
    })
}

export function parseNumberInQuery (filters: T.Dictionary<any>, path: string) {
    const value = _get(filters, path)
    if (!!value || (typeof value === 'string' && value.length === 0)) {
        const parsed = parseInt(value)
        _set(filters, path, isNaN(parsed) ? null : parsed)
    }
}
